import React, { useCallback } from 'react';
import update from 'immutability-helper';
import { useDispatch, useSelector } from 'react-redux'
import { setStepNumberState, handleClearHistory } from 'actions/livefeed/historyActions'
import { setNewSlideOrder, goToSlide, addSlide, removeSlide, addSumSlide } from 'actions/livefeed/slideCrudActions';
import { Container, Draggable } from 'react-smooth-dnd';
import defaultEditorState from 'components/pages/livefeed/defaultstate';
import { setMapConfigMode } from 'actions/livefeed/steerpathMapActions'
import SlideTypesAdd from './SlideTypesAdd'
import { generateSlideName } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'

const SlidesContainer = () => {
    const dispatch = useDispatch();
    const { stepNumberState, livefeedSlides, slideCurrentIndex } = useSelector(state => state.livefeededitor)
    // add dynamic slide id
    livefeedSlides.map((obj, i) => {
        obj.id = i
        return obj
    })

    const moveToSlide = useCallback((e, index) => {
        if (livefeedSlides[index].slideType === "slideshow") {
            // prevent duplicate dispatch
            let mapConfigMode = "user_input"
            dispatch(setMapConfigMode(mapConfigMode))
        }
        if (slideCurrentIndex !== index) {
            // Move to slide index
            e !== null && e.stopPropagation();
            /*First clear history of the slideCurrentIndex and setStepNumberState to 0
             Then goToSlide to the target slide
            */
            dispatch(handleClearHistory(slideCurrentIndex))
            stepNumberState !== 0 && dispatch(setStepNumberState(0));
            dispatch(goToSlide(index));
        }
    }, [dispatch, livefeedSlides, stepNumberState, slideCurrentIndex])


    const removeSlideHandle = useCallback((e, index) => {
        //remove slide
        e !== null && e.stopPropagation();
        /*First clear history of the slideCurrentIndex and setStepNumberState to 0
        Then goToSlide to the target slide
        */
        dispatch(handleClearHistory(slideCurrentIndex))
        dispatch(setStepNumberState(0));
        dispatch(goToSlide(index));
        //Target slide to be deleted is  1 and  0, goToSlide to 0
        if (index <= 1) {
            dispatch(goToSlide(0))
        }
        // Target slide to be deleted is the last slide, then just goToSlide minus 1
        else if (livefeedSlides.length - 1 === index) {
            dispatch(goToSlide(index - 1))
        }

        let pairedSlideIndex = null; // summary & locationsList slide
        if (livefeedSlides[index].slideType === "summary") {
            for (let i = 0, n = livefeedSlides.length; i < n; i++) {
                if (livefeedSlides[i].slideType === "locationsList") {
                    pairedSlideIndex = i
                }
            }
        }

        if (pairedSlideIndex !== null) {
            const valuesArr = livefeedSlides.slice()
            const removeValFromIndex = [index, pairedSlideIndex]
            const indexSet = new Set(removeValFromIndex);
            const arrayWithValuesRemoved = valuesArr.filter((_, i) => !indexSet.has(i));
            dispatch(setNewSlideOrder(arrayWithValuesRemoved))
        } else {
            dispatch(removeSlide(index))
        }

    }, [dispatch, livefeedSlides, slideCurrentIndex])


    let summaryPageIndex = undefined;
    let firstSlideShowIndex = undefined;
    let locationsListIndex = undefined
    for (let i = 0, n = livefeedSlides.length; i < n; i++) {
        livefeedSlides[i].slideType === "summary" && (summaryPageIndex = i)
        livefeedSlides[i].slideType === "slideshow" && (firstSlideShowIndex = i)
        livefeedSlides[i].slideType === "locationsList" && (locationsListIndex = i)
    }

    const addSlideHandle = useCallback((e, type) => {
        e.stopPropagation();
        dispatch(handleClearHistory(0))
        dispatch(setStepNumberState(0));
        let template;

        switch (type) {
            case "locationsList": {
                template = defaultEditorState.livefeedSlides.slice()
                let locationsList = update(template[1], {
                    historyEntities: [{
                        fontFamily: { $set: livefeedSlides[0].fontFamily } // get fontFamily of summary slide
                    }],
                    logoState: {
                        slideCurrentIndex: { $set: livefeedSlides.length },
                        url: { $set: livefeedSlides.slice()[0].logoState.url }
                    }
                })
                const newArrOrder = livefeedSlides.slice()
                newArrOrder.splice(1, 0, locationsList);
                dispatch(setNewSlideOrder(newArrOrder))// push to index 1
                dispatch(goToSlide(1))
            }
                break;
            case "summary": {
                template = defaultEditorState.livefeedSlides.slice()
                dispatch(addSumSlide(template[1]))// unshift to the begining
                dispatch(addSumSlide(template[0])) // unshift to the begining
                dispatch(goToSlide(0))
            }
                break;
            case "slideshow": {
                // get firstSlideShow as template if exits, otherwise get template from defaultEditorState
                template = firstSlideShowIndex !== undefined ? livefeedSlides.slice()[firstSlideShowIndex] : defaultEditorState.livefeedSlides.slice()[2]
                // specific objects need to be updated only for slideshow template
                template = update(template, {
                    leftPanelBg: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    },
                    rightPanelBg: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    }
                })
                let { fontFamily, textContainer } = template

                template = update(template, {
                    historyEntities: {
                        $set:
                            [{
                                id: null,
                                fontFamily: fontFamily // get font family of the first slide as template
                            }]
                    },
                    floorplanOptions: {
                        location: { $set: { value: null, label: null } }
                    },
                    logoState: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    },
                    lineState: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    },

                    rightPanelTextTitle: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    },
                    rightPanelGaugeValueLabel: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    },
                    rightPanelGaugeOccupiedBg: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    },
                    rightPanelGaugeOffsetdBg: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    },
                    rightPanelGaugeNeedle: {
                        slideCurrentIndex: { $set: livefeedSlides.length }
                    }
                })
                for (let i = 0; i < textContainer.length; i++) {
                    template = update(template, {
                        textContainer: { [i]: { slideCurrentIndex: { $set: livefeedSlides.length } } }
                    })
                }
                dispatch(addSlide(template))
                dispatch(goToSlide(livefeedSlides.length))
            }
                break;
        }

    }, [dispatch, firstSlideShowIndex, livefeedSlides])

    const applyDrag = useCallback((arr, dragResult) => {
        const { removedIndex, addedIndex, payload } = dragResult;
        if (removedIndex === null && addedIndex === null) return arr;

        const result = [...arr];
        let itemToAdd = payload;

        if (removedIndex !== null) {
            itemToAdd = result.splice(removedIndex, 1)[0];

        }

        if (addedIndex !== null) {
            result.splice(addedIndex, 0, itemToAdd);

        }
        return { result, addedIndex };
    }, [])

    const onMouseDownDragHandle = useCallback((e, slideId) => {
        moveToSlide(e, slideId);
    }, [moveToSlide])

    const sortSlideHandle = useCallback((dropResult) => {
        const { result, addedIndex } = applyDrag(livefeedSlides, dropResult)
        dispatch(setNewSlideOrder(result))
        moveToSlide(null, addedIndex)

    }, [applyDrag, dispatch, livefeedSlides, moveToSlide])

    //----------------------------------render functions

    function renderDeleteBtn(slide) {
        if (livefeedSlides.length > 1) {
            let slideDeletable = true
            let length2 = livefeedSlides.length === 2 // if there are 2 slides;
            let isPairedSlide = summaryPageIndex !== undefined && locationsListIndex !== undefined
            if (slide.slideType === "summary" && isPairedSlide && length2) {
                slideDeletable = false // summary page can not be deleted
            }
            if (slideDeletable) {
                return (
                    <i className="material-icons slide_delete"
                        onClick={(e) => removeSlideHandle(e, slide.id)}>
                        &#xe14c;
                    </i>
                )
            }
        }
    }

    return (
        <React.Fragment>
            <div className="slide-preview">
                <div className="slide-scroll">
                    <div className="slide-header">Slide No.</div>
                    <Container
                        dragClass="opacity-ghost"
                        dropClass="opacity-ghost-drop"
                        animationDuration={500}
                        dropPlaceholder={{
                            animationDuration: 150,
                            showOnTop: true,
                            className: 'drop-preview'
                        }}
                        dropPlaceholderAnimationDuration={200}
                        dragHandleSelector=".column-drag-handle"
                        onDrop={dropResult => sortSlideHandle(dropResult)}
                    >
                        {livefeedSlides.map(slide =>
                            <Draggable key={slide.id} >
                                <div className={`slide ${slide.id === slideCurrentIndex ? 'current' : ''}`}
                                    onClick={(e) => moveToSlide(e, slide.id)}>
                                    <i onMouseDown={(e) => onMouseDownDragHandle(e, slide.id)}
                                        className="column-drag-handle material-icons">
                                        drag_handle</i>
                                    {renderDeleteBtn(slide)}
                                    <span style={{ letterSpacing: -1 }}>{generateSlideName(livefeedSlides, slide)}</span>
                                </div>
                            </Draggable>
                        )}
                    </Container>
                    <SlideTypesAdd
                        dispatch={dispatch}
                        slideType={livefeedSlides[slideCurrentIndex].slideType}
                        locationsListIndex={locationsListIndex}
                        summaryPageIndex={summaryPageIndex}
                        addSlideHandle={(e, type) => addSlideHandle(e, type)}
                    />
                </div>


            </div>
        </React.Fragment>

    );
}
export default SlidesContainer;





// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/SlidesContainer/index.jsx